import styled from 'styled-components';
import { DatePicker } from 'antd';

export const DatePickerWrapper = styled(DatePicker)`
	width: 100%;
	border-radius: 4px;
	height: 40px !important;
	font-size: 16px !important;
	font-weight: 400 !important;
	border: 1px solid ${({ theme }) => theme.palette.secondary['150']};

	.ant-picker-suffix {
		color: ${({ theme }) => theme.colors.text};
	}
`;
